const Preload = () => {
  return <div>ХYЮЗКААААААААААААА</div>;
};
export default Preload;
